import React from 'react';
import './Spinner.css';

const Spinner = ({ size = 'md', className = '', ...props }) => {
    return (
        <div className={`spinner-wrapper size-${size} ${className}`} {...props}>
            <div className="spinner-circle"></div>
        </div>
    );
};

export default Spinner;
